<template>
  <PrivacySection title="2. Account Utente">
    <p>
      L'applicazione <strong>App degli Scontrini</strong> <strong>non richiede la
      creazione di un account</strong> sui nostri server. Non esiste un profilo utente
      registrato presso ISIGest S.r.l.
    </p>
    <PrivacyBox>
      <p>
        <strong>Cosa significa:</strong> non è necessario eliminare un account online.
        I dati dell'app sono memorizzati principalmente sul dispositivo dell'utente
        e possono essere rimossi direttamente dall'applicazione o disinstallando l'app.
      </p>
    </PrivacyBox>
    <p>
      Se hai inviato richieste tramite il modulo di contatto del sito web o dell'app,
      i relativi dati (nome, email, messaggio) sono conservati sui nostri sistemi e
      possono essere eliminati su richiesta tramite il form in fondo a questa pagina.
    </p>
  </PrivacySection>
</template>

<script>
import PrivacySection from '@/components/privacy/PrivacySection.vue'
import PrivacyBox from '@/components/privacy/PrivacyBox.vue'

export default {
  name: 'AccountStatusSection',
  components: {
    PrivacySection,
    PrivacyBox
  }
}
</script>
